import styled from '@emotion/styled';
import {
  Row,
  Button,
  Th,
  Td,
  Column,
  SelectorTabs,
  DateInput,
  stickyFirstColumn,
  device,
  typography,
} from '@landsbankinn/ui';
import React from 'react';
import { MarketsFormatNumber } from './MarketsFormatNumber';
import { PosNegArrow } from './PosNegArrow';

// Texti +
export const MarketsSmall = styled.p<{ noWrap?: boolean }>`
  ${typography.bodySmall}
  white-space:${({ noWrap }) => (noWrap ? 'nowrap' : 'normal')};
`;

export const MarketsSmallFadeToRight = styled.p<{ fading?: boolean }>`
  ${typography.bodySmall}
  white-space: nowrap;
  position: absolute;
  bottom: 8px;
  ${(props) =>
    props.fading
      ? `
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;    
    height: 100%;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      white 80%,
      white 100%
    );
  }`
      : ''};
`;

export const MarketsSmallBold = styled.p`
  ${typography.bodySmall}
  font-weight:bold;
`;

export const MarketsSmallBold20 = styled.p`
  ${typography.bodySmallBold}
`;

export const MarketsBody = styled.p`
  ${typography.body}
`;

export const MarketsBodyBold = styled.p<{ noWrap?: boolean }>`
  ${typography.body}
  font-weight: bold;
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'normal')};
`;

export const MarketsP2 = styled.p`
  ${typography.p2}
`;

export const MarketsSummaryTitle = styled.a`
  ${typography.h4}
  padding-bottom: 5px;
  font-weight: 500;
`;

export const MarketsListTitle = styled.h1`
  ${typography.h2Big}
`;

export const MarketsListTitleMobile = styled(MarketsSmallBold)`
  padding-bottom: 2px;
`;
// Texti -

// Tölur +
export const MarketsNumberSmall = styled(MarketsFormatNumber)`
  ${typography.bodySmall}
`;

export const MarketsNumberSmallBold = styled(MarketsFormatNumber)`
  ${typography.bodySmall}
  font-weight: 500;
`;

export const MarketsNumberSmallBold20 = styled(MarketsFormatNumber)`
  ${typography.bodySmallBold}
`;

export const MarketsNumberBold = styled(MarketsFormatNumber)`
  ${typography.body}
  font-weight: 500;
`;

export const MarketsNumber4Big = styled(MarketsFormatNumber)`
  ${typography.numbers4Big}
`;

export const MarketsNumberBig = styled(MarketsFormatNumber)`
  ${typography.numbersBig}
  font-weight: 500;

  padding-bottom: 25px;
  border-bottom: 1px solid rgba(37, 46, 72, 0.33);
`;
// Tölur -

// Töflur +
export const MarketsTh = styled(Th)`
  white-space: nowrap;
`;
export const MarketsTd = styled(Td)`
  white-space: nowrap;
`;
// Töflur -

// Layout +
export const TwoNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RightAlignColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
// Layout -

// Stakt verðbréf +

export const InfoRow = styled(Row)`
  margin-bottom: 20px;

  > div:nth-child(2) > div {
    border-top: 1px solid rgba(37, 46, 72, 0.33);
    border-bottom: 1px solid rgba(37, 46, 72, 0.33);
  }

  > div:nth-child(3) > div,
  > div:nth-child(4) > div {
    border-bottom: 1px solid rgba(37, 46, 72, 0.33);
  }

  @media ${device.tablet} {
    > div:nth-child(2) > :nth-child(2) {
      border-top: none;
    }
    > div:nth-child(3) > :first-child,
    > div:nth-child(4) > :first-child {
      border-top: 1px solid rgba(37, 46, 72, 0.33);
    }
  }
`;

export const InfoColumn = styled(Column)`
  display: flex;
  flex-direction: row;

  @media ${device.tablet} {
    flex-direction: column;
  }
`;

export const PriceColumn = styled(Column)`
  padding-top: 0px;
  padding-bottom: 0px;

  @media ${device.tablet} {
    margin-bottom: 11px;
  }
  @media ${device.desktop} {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

export const SecurityPrice = styled(MarketsFormatNumber)`
  ${typography.numbersMedium}
  font-weight: 500;

  padding-bottom: 16px;

  @media ${device.tablet} {
    ${typography.numbersBig}
    font-weight: 500;
    font-size: 60px !important;
    padding-bottom: 0px;
    border-bottom: none;
  }
`;

export const ColumnContainer = styled(RightAlignColumnContainer)`
  align-items: flex-start;
  margin-left: 10px;

  padding-bottom: 29px;

  @media ${device.tablet} {
    border-bottom: none;
    padding-bottom: 8px;
  }
  @media ${device.desktop} {
    align-items: flex-end;

    border-bottom: none;
    padding-bottom: 8px;
  }
`;

export const Arrow = styled(PosNegArrow)`
  margin-right: 7px;
`;

export const MarketsSmallLeft = styled.p`
  ${typography.bodySmall}
  text-align: left;
  margin-bottom: 22px;

  @media ${device.tablet} {
    margin-bottom: 10px;
  }
`;

export const SecurityTitle = styled(Row)`
  padding-top: 40px;
  margin-bottom: 45px;
  position: relative;

  @media ${device.tablet} {
    margin-bottom: 30px;
    padding-top: 65px;
  }
`;

export const BuyButton = styled(({ ...rest }) => <Button {...rest} />)`
  max-width: initial;
  width: 95px;
  padding: 0px !important;
  display: flex;
  max-height: 40px;
  min-height: 40px;

  margin-top: 30px;
  margin-bottom: 30px;

  div {
    font-size: 16px;
  }

  @media ${device.tablet} {
    width: 100%;
    margin-top: 40px;
    max-height: 52px;
    min-height: 52px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

export const BorderedButton = styled(({ ...rest }) => (
  <Button bordered {...rest} />
))`
  min-width: 100%;
  min-height: 52px;

  div {
    font-size: 16px;
  }
`;

export const MarketsRow = styled(Row)`
  margin-bottom: 50px;
`;

export const MarketsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  padding-left: 0px;
  padding-top: 11px;
  padding-bottom: 1px;
  min-height: 112px;

  &:first-child {
    margin-right: 10px;
  }
  &:last-child {
    border-top: none;
    margin-left: 10px;
  }

  @media ${device.tablet} {
    padding-left: 2px;
    padding-bottom: 0px;

    &:first-child {
      margin-right: 0px;
    }
    &:last-child {
      margin-left: 0px;
    }
  }
`;

export const PriceChangeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-grow: 1;
  align-items: flex-end;

  padding-top: 32px;
  & > span {
    margin-right: 10px;
  }

  @media ${device.desktop} {
    justify-content: space-between;
    padding-top: 0px;
    & > span {
      margin-right: 0px;
    }
  }
`;

export const PriceChangeColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-grow: 1;
  align-items: flex-start;
`;

export const MarketsPriceColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-bottom: none;

  @media ${device.tablet} {
    padding-top: 10px;
    border-top: 1px solid rgba(37, 46, 72, 0.33);
  }
  @media ${device.desktop} {
    &:last-child {
      border-top: 1px solid rgba(37, 46, 72, 0.33);
    }

    border-bottom: 1px solid rgba(37, 46, 72, 0.33);
  }
`;

export const MarketsSpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const MarketsNumberBond = styled(MarketsFormatNumber)`
  ${typography.numbers4Big}
  line-height: 1;
  padding-bottom: 10px;

  @media ${device.tablet} {
    line-height: 1.75;
    padding-bottom: 0px;
  }
`;
export const MarketsSmallNumberBond = styled(MarketsFormatNumber)`
  ${typography.bodySmall}
  font-weight: 500;

  @media ${device.tablet} {
    ${typography.bodySmallBold}
  }
`;

// Stakt verðbréf -

// Summary pages +
export const MarketsTableContainer = styled.div`
  padding-top: 26px;

  @media ${device.tablet} {
    padding-top: 30px;
  }
`;

export const MarketsContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 25px;

  @media ${device.tablet} {
    padding-top: 37px;
  }
`;

export const TypeContainer = styled(Row)`
  margin-bottom: 3px;

  @media ${device.tablet} {
    margin-bottom: 12px;
  }
`;

export const StatusColumn = styled(Column)`
  display: flex;
  justify-content: flex-end;

  margin-bottom: 36px;
  @media ${device.tablet} {
    margin-bottom: 0px;
  }
`;

export const HistoryContainer = styled.div<{ open: boolean }>`
  padding-top: 10px;

  @media ${device.tablet} {
    padding-top: ${(props) => (!props.open ? ' 48px' : '76px')};
  }
`;

export const SummaryChartContainer = styled.div`
  padding-top: 46px;
  height: 245px;

  @media ${device.tablet} {
    padding-top: 0px;
    height: 210px;
  }
`;

export const MarketsSummarySelectorTabs = styled(SelectorTabs)<{
  color: string;
}>`
  & > div {
    padding-bottom: 0px;
  }

  & > div > button {
    ${typography.bodySmall}
    padding-bottom: 0px;
    min-height: 41px;
  }

  & > div:last-child {
    background-color: ${({ color }) => color};
  }
`;

export const SummaryFootnoteContainer = styled.div`
  padding-top: 8px;
  display: flex;
  justify-content: flex-end;
`;
// Summary pages -

// List pages +
export const ListHeaderContainer = styled(Row)`
  padding-top: 26px;
  margin-bottom: 30px;
  justify-content: space-between;
  & > div {
    padding-bottom: 18px;
  }
  @media ${device.tablet} {
    padding-top: 32px;
    margin-bottom: 60px;

    & > div {
      flex-shrink: 2;
      padding-bottom: 0px;
    }
    & > div:last-child {
      width: auto;
    }
  }
`;

export const MarketsSelectorTabs = styled(SelectorTabs)<{
  color: string;
  alignLeft?: boolean;
}>`
  justify-content: ${(props) => (props.alignLeft ? 'flex-start' : 'flex-end')};

  & > div {
    width: auto;
  }
  & > div:nth-last-child(2) {
    width: auto;
    margin-right: 0px;
  }

  padding-top: 28px;

  & > div > button {
    position: relative;
  }
  & > div > button:after {
    content: '';
    padding: 0px 40px;
    position: absolute;
    left: -20px;
    top: 0px;
    width: calc(100% + 40px);
    height: 100%;
  }

  & > div:last-child {
    background-color: ${({ color }) => color};
  }
`;

export const StickyFirstColumn = styled.div`
  ${stickyFirstColumn}
`;

export const MarketsDateInput = styled(DateInput)`
  & input {
    background-color: rgba(244, 247, 247, 1);
  }
  &:hover {
    box-shadow: 0 0 0 0px;
  }

  & > div:last-child {
    top: 25%;
  }

  @media ${device.tablet} {
    & > div:last-child {
      top: 50%;
    }
  }
`;

// List pages -

// Enums +
export enum LineDistribution {
  Linear = 'linear',
  Series = 'series',
}
// Enums -
